module.exports = __webpack_public_path__ + "img/hj006.e34bdf03.jpg";